import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { Storage } from "@faire/web/common/Storage";

export const getBuilderAPIKey = () => {
  return getGlobalProperty<string>("builderIOApiKey");
};

export const getLocaleId = (): string | undefined => {
  return getGlobalProperty("localeId");
};

export const getSessionCountry = (): keyof typeof ISO3166Alpha3 | undefined => {
  return getGlobalProperty<keyof typeof ISO3166Alpha3>("sessionCountry");
};

export const isE2E = () => {
  // Used in Cypress code which is outside the module
  const IS_E2E_TEST_FLAG = "IS_E2E_TEST";
  return Storage.local.getItem(IS_E2E_TEST_FLAG);
};
